import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { exportCategoryThunk, getAllCategoriesThunk, setCategoriesPage, setCategoryRefresh } from '../../../redux/category/getAllCategorySlice';
import api from '../../../utils/api';
import { toast } from 'react-toastify';
import MasterHeader from '../../../component/reusable/MasterHeader';
import { exportDataExcel, fomateDate } from '../../../utils/fomateDate';
import CategoriesTable from '../../../component/categoryComps/CategoriesTable';



const Category = () => {

  const [statuss, setStatus] = useState("");
  const [search, setSearch] = useState('')
  const [limit, setLimit] = useState(25)
  const [sortBy, setSortyBy] = useState('createdAt');
  const [order, setOrder] = useState('asc')
  const navigate = useNavigate()
  const dispatch = useDispatch()


  const { categories, loading, error, refresh, exportLoading, page } = useSelector((state) => state.categories);

  const totalPages = categories?.totalPages
  const totalItems = categories?.totalItems
  const itemsPerPage = categories?.limit


  // calculate start & end of items -------------------
  const start = (page - 1) * limit + 1;
  const end =
    totalPages === page
      ? totalItems
      : (page - 1) * limit + limit;



  console.log(categories);


  useEffect(() => {
    dispatch(getAllCategoriesThunk(`?search=${search}&page=${page}&status=${statuss}&limit=${limit}&sortBy=${sortBy}&order=${order}`));
  }, [page, search, statuss, limit, refresh, sortBy, order]);



  const handleFileChange = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('file', file);

      const response = await api.addBulkCategory(formData);
      if (response.data) {
        toast.success(response?.data?.data?.message)
        dispatch(setCategoryRefresh());
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || 'Something went wrong')
    }
  };


  const exportData = async () => {
    const status = await dispatch(exportCategoryThunk())

    if (status?.payload?.success === true) {
      const categoriess = status?.payload?.data
      const exportdata = categoriess?.map((item) => ({
        'name': item?.name || '-',
        'productCount': item?.productCount || 0,
        'description': item?.description,
        'cover_image': item?.cover_image?.map(i => i)?.join(', ') || '-',
        'thumbnail_photo': item?.thumbnail?.photo?.map(i => i)?.join(', ') || '-',
        'thumbnail_status': item?.thumbnail?.status,
        'createdAt': fomateDate(item?.createdAt),
      }))
      exportDataExcel(exportdata, "category")
    }
  }


  const handleOpenMenu = (sort) => {
    setSortyBy(sort)
    setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
  };


  return (
    <div>
      <MasterHeader
        index="Category"
        root="Dashboard"
        setStatus={setStatus}
        setSearch={setSearch}
        handleFileChange={handleFileChange}
        onClickadd={() => navigate('/master/addCategory')}
        buttonText={'Add Category'}
        exportData={exportData}
        exportLoading={exportLoading}
      />
      {loading ?
        <div>
          Please wait...
        </div>
        :
        <>
          {
            categories?.data?.length > 0 ?
              <CategoriesTable
                categories={categories}
                page={page}
                setPage={setCategoriesPage}
                itemsPerPage={itemsPerPage}
                totalItems={totalItems}
                totalPages={totalPages}
                start={start}
                end={end}
                handleOpenMenu={handleOpenMenu}
              />
              :
              <div>
                No categories found
              </div>

          }
        </>
      }


    </div>

  );
};

export default Category;


